import { useState } from "react";
import { FilePlus2 } from "lucide-react";
import GoalForm from "@/components/GoalForm";

export default function NovaGoalPanel({ onSaved }) {
  const [formKey, setFormKey] = useState(0);

  return (
    <div data-testid="nova-meta-panel" className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 sm:p-8 max-w-2xl">
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-xl bg-blue-800 flex items-center justify-center shrink-0">
          <FilePlus2 className="w-6 h-6 text-white" />
        </div>
        <div>
          <h2 className="font-heading text-xl sm:text-2xl font-bold text-slate-900">Gerar novo boleto / meta</h2>
          <p className="text-sm sm:text-base text-slate-500">
            Preencha os campos e clique em gerar. O documento visual da guia Pix é criado automaticamente — não é necessário criar imagem de boleto.
          </p>
        </div>
      </div>
      <GoalForm
        key={formKey}
        submitLabel="GERAR BOLETO / META"
        onSaved={() => {
          setFormKey((k) => k + 1);
          onSaved?.();
        }}
      />
    </div>
  );
}
